export default "__VITE_ASSET__Bdjjv3Hl__"